module.exports = __webpack_public_path__ + "img/2-right.e07655bc.svg";